/* eslint-disable no-unused-vars */
/* eslint-disable import/no-useless-path-segments */
import React, { useContext, useEffect, useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import GatsbyImage from 'gatsby-image'
import { useInView } from 'react-intersection-observer'
import ReviewStarsProduct from './ReviewStarsProduct'
import { LayoutContext, useUI } from '../../contexts'
import Price from '../Price'
import { SiteLink } from './SiteLink'
import { useProductClickedTracking } from '../../hooks/tracking'
import ProductLabelLogo from '../product/ProductLabelLogo'
import { useGlobal } from '../../hooks/useGlobal'
import { camelize, getDiscountPercentage } from '../../utils'
import { desktopVW, mobileVW } from '../../styles'
import useShopifyProduct from '../../hooks/useShopifyProduct'
import { useShopify } from '../../contexts/shopify'

const ProductThumbnail = ({
  image,
  slug,
  extension,
  title,
  shopifyProduct,
  thumbnailSubheading,
  family,
  label,
  logo,
  featuredCollection = false,
  loadingOrder = null,
  viewType,
  sectionType,
  location,
  alternativeLayout = false, // black friday layout
}) => {
  const isSkiing = family?.name.toLowerCase().includes('skiing')
  const { currency, node_locale, storeSubdomain } = useContext(LayoutContext)
  const { checkouts: allCheckouts } = useShopify()
  const checkouts = allCheckouts[storeSubdomain]
  const [bigDiscount, setBigDiscount] = useState(false)

  useEffect(() => {
    setBigDiscount(
      checkouts?.lineItems?.edges
        .filter((edge) => !edge?.node?.title.toLowerCase().includes('skiing'))
        .filter((edge) => !edge?.node?.title.toLowerCase().includes('gift'))
        .length > 0,
    )
  }, [checkouts.lineItems.edges.length])

  const { setSearchOpen } = useUI()
  const {
    blackFriday: {
      salesDay,
      blackFriday2022,
      cyberMonday,
      colorStrikethrough,
      blackFridayThemeColor,
      showAnnouncementBarBlackFriday2022,
      shortBlackFridayOffer2022,
    },
  } = useGlobal(['blackFriday'], node_locale)

  const [discountPrice, setDiscountPrice] = useState('')
  const [originalPrice, setOriginalPrice] = useState('')
  const salesDays = { blackFriday2022, cyberMonday }

  const { product } = useShopifyProduct(shopifyProduct.handle)

  const isIE =
    /*@cc_on!@*/ false ||
    (typeof window !== `undefined` && !!document.documentMode)
  const [thumbnail, thumbnailInView] = isIE
    ? []
    : useInView({ triggerOnce: true, threshold: 0 })

  const getPrice = (slug) => {
    const priceEl = document.querySelector(
      `.product-link .product-detail.${slug}`,
    )
    if (priceEl) {
      const amount = Number(
        priceEl.textContent
          .replace(currency?.symbol, '')
          .replace(`${title} - `, ''),
      )
      return amount
    } else {
      return null
    }
  }

  useEffect(() => {
    if (product) {
      const originalPrice =
        product.variants.edges[0].node.presentmentPrices.edges[0].node
          .compareAtPrice

      if (originalPrice) {
        setOriginalPrice(
          parseFloat(
            product.variants.edges[0].node.presentmentPrices.edges.find(
              ({
                node: {
                  compareAtPrice: { currencyCode },
                },
              }) => currencyCode === currency.code,
            ).node.compareAtPrice.amount,
          ),
        )
        setDiscountPrice(
          parseFloat(
            product.variants.edges[0].node.presentmentPrices.edges.find(
              ({
                node: {
                  price: { currencyCode },
                },
              }) => currencyCode === currency.code,
            ).node.price.amount,
          ),
        )
      } else {
        setDiscountPrice(
          parseFloat(
            product.variants.edges[0].node.presentmentPrices.edges.find(
              ({
                node: {
                  price: { currencyCode },
                },
              }) => currencyCode === currency.code,
            ).node.price.amount,
          ),
        )
      }
    }
  }, [product])

  {
    /**
     * As titles often are identical e.g. Sports Socks Men
     * use slug, to generate more specific title
     */
  }

  const ariaLabel = `Go to ${slug
    .replaceAll('-', ' ')
    .replaceAll('_', ' ')} product`

  return (
    <ProductLink
      to={slug}
      extension={extension}
      className={`product-link ${
        sectionType === 'Featured Collection' ? 'featured-collection' : ''
      }`}
      onClick={() => {
        setSearchOpen(false)
        useProductClickedTracking({
          currency: currency?.code,
          locale: node_locale,
          family: family.name,
          label: title,
          price: getPrice(slug),
          quantity: 1,
          linkType: 'Image',
          viewType: viewType,
          sectionType: sectionType,
          destination: `/${node_locale}/${slug}/`,
        })
      }}
      state={{ referrer: location?.pathname }}
      aria-label={ariaLabel}
    >
      <LazyLoadThumbnail ref={thumbnail}>
        <AriaLabel>{ariaLabel}</AriaLabel>
        {/* {salesDay && showAnnouncementBarBlackFriday && (
          <SalesDay>{salesDays[camelize(salesDay)]}</SalesDay>
        )} */}
        {!isSkiing && showAnnouncementBarBlackFriday2022 && (
          <>
            <BFLabel featuredCollection={featuredCollection}>
              {blackFriday2022}
            </BFLabel>
            <BFLabelTwo featuredCollection={featuredCollection}>
              {shortBlackFridayOffer2022}
            </BFLabelTwo>
          </>
        )}

        {(isSkiing || !showAnnouncementBarBlackFriday2022) && (
          <ProductLogoWrapper aria-hidden>
            <ProductLabelLogo label={label} logo={logo} />
          </ProductLogoWrapper>
        )}

        <ProductImageWrapper className='product-image-wrapper'>
          {/* Alternative Layout = Black Friday */}

          {/* {alternativeLayout && product && originalPrice && discountPrice && (
            <>
              <ProductLabelLogo label='Percentage'>
                -{getDiscountPercentage(discountPrice, originalPrice)}
              </ProductLabelLogo>
              <Prices>
                <PriceWrapper
                  original
                  color={blackFridayThemeColor || '#FF0058'}
                >
                  <Price shopifyProduct={shopifyProduct} amount={1} discount={} />
                </PriceWrapper>
                <PriceWrapper
                  strikethrough
                  strikethroughColor={blackFridayThemeColor || '#FF0058'}
                  color={colorStrikethrough}
                >
                  {node_locale === 'de' || node_locale === 'fr'
                    ? `${originalPrice} ${currency.symbol}`
                    : `${currency.symbol}${originalPrice}`}
                </PriceWrapper>
              </Prices>
            </>
          )} */}

          {!isIE && thumbnailInView ? (
            <ProductImage
              className={'featuredCollection_custom_image'}
              fluid={image.fluid}
              alt={image.title}
              loading={
                loadingOrder || loadingOrder === 0
                  ? loadingOrder < 8
                    ? 'eager'
                    : 'lazy'
                  : 'lazy'
              }
            />
          ) : isIE ? (
            <ProductImage
              className={'featuredCollection_custom_image'}
              fluid={image.fluid}
              alt={image.title}
              loading={
                loadingOrder || loadingOrder === 0
                  ? loadingOrder < 8
                    ? 'eager'
                    : 'lazy'
                  : 'lazy'
              }
            />
          ) : null}
        </ProductImageWrapper>
        <div aria-hidden className={'featuredCollection_custom_text'}>
          <ProductDetail className={`product-detail ${slug}`}>
            {/* {showAnnouncementBarBlackFriday && node_locale !== 'en-US' ? (
              title
            ) : ( */}
            <>
              {`${title} - `}
              {showAnnouncementBarBlackFriday2022 && !isSkiing ? (
                <>
                  <PriceWrapper original color={'#FF1E00'}>
                    <Price
                      shopifyProduct={shopifyProduct}
                      amount={1}
                      discount={
                        bigDiscount ? discountPrice * 0.4 : discountPrice * 0.25
                      }
                    />
                  </PriceWrapper>
                  <PriceWrapper
                    strikethrough
                    strikethroughColor={blackFridayThemeColor || '#FF1E00'}
                    color={colorStrikethrough}
                  >
                    <Price shopifyProduct={shopifyProduct} amount={1} />
                  </PriceWrapper>
                </>
              ) : (
                <Price shopifyProduct={shopifyProduct} amount={1} />
              )}
            </>
            {/* )} */}
          </ProductDetail>
          {!featuredCollection && (
            <Reviews className='reviews' legacy_skus={family.legacySkus} />
          )}
          {thumbnailSubheading && (
            <ProductSubheading className='product-subheading'>
              {thumbnailSubheading}
            </ProductSubheading>
          )}
        </div>
      </LazyLoadThumbnail>
    </ProductLink>
  )
}

const BFLabel = styled.div`
  position: absolute;
  top: ${({ featuredCollection }) => (featuredCollection ? '-4.38vw' : '2vw')};
  right: ${({ featuredCollection }) =>
    featuredCollection ? '-4.38vw' : '2vw'};
  color: #ff1e00;
  width: min-content;
  font-family: AkiraExpanded;
  z-index: 10;
  font-size: 3.2vw;
  text-align: center;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: 1.6vw;
    top: ${({ featuredCollection }) =>
      featuredCollection ? '-3.38vw' : '1vw'};
    right: ${({ featuredCollection }) =>
      featuredCollection ? '-3.38vw' : '1vw'};
  }
`

const BFLabelTwo = styled.div`
  position: absolute;
  top: ${({ featuredCollection }) => (featuredCollection ? '38vw' : '37vw')};
  left: ${({ featuredCollection }) => (featuredCollection ? '-8vw' : '0vw')};
  padding: 1vw;
  font-size: 3.2vw;
  color: white;
  background-color: #ff1e00;
  z-index: 10;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: 1.4vw;
    padding: 0.5vw;
    left: ${({ featuredCollection }) =>
      featuredCollection ? '-4.38vw' : '0vw'};
    top: ${({ featuredCollection }) => (featuredCollection ? '16vw' : '15vw')};
  }
`

const LazyLoadThumbnail = styled.div`
  position: relative;
`

const SalesDay = styled.p`
  z-index: 1;
  position: absolute;
  font-size: ${(props) => props.theme.fontSize.m23};
  color: ${(props) => props.theme.colors.lightBlack};

  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    top: 5vw;
    left: 4vw;

    .featured-collection & {
      top: -2vw;
      left: -4vw;
    }
  }

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d14};
    margin: ${desktopVW(40)} 0 0 ${desktopVW(25)};

    .featured-collection & {
      margin: -${desktopVW(40)} 0 0 -${desktopVW(55)};
    }
  }
`

const Prices = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0 ${mobileVW(10)} ${mobileVW(10)} 0;
  z-index: 1;

  .featured-collection & {
    margin: 0 ${mobileVW(-15)} ${mobileVW(-20)} 0;
  }

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin: 0 ${desktopVW(20)} ${desktopVW(20)} 0;

    .featured-collection & {
      margin: 0 ${desktopVW(-60)} 0.7vw 0;
    }
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const PriceWrapper = styled.span`
  position: relative;
  margin-left: 0.3rem;
  color: ${({ original, color }) => (original ? color : 'inherit')};
  display: inline-block;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin-left: 0.38vw;
  }

  &::after {
    content: '';
    position: absolute;
    display: ${(props) => (props.strikethrough ? 'block' : 'none')};
    left: -0.15em;
    right: -0.15em;
    top: 50%;
    border-top: 1px solid
      ${({ strikethroughColor }) => strikethroughColor || '#FF1E00'};
    transform: rotate(-20deg);
  }
`

const Reviews = styled(ReviewStarsProduct)`
  padding-top: ${(props) => props.theme.space.marginMobile / 3}vw;

  svg {
    &:not(:last-child) {
      margin-right: 0;
    }
  }

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding-top: 0;
    opacity: 1;

    svg,
    svg:not(:last-child) {
      margin-right: 0.08625vw;
    }
  }

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    display: none;
  }
`

const ProductLink = styled(SiteLink)`
  text-decoration: none;
  position: relative;
  width: 100%;
  &:hover {
    ${Reviews} {
      opacity: 1;
    }
  }
`

const ProductImageWrapper = styled.div`
  position: relative;
  background: #f6f6f6;
  height: 62vw;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: 27vw;
  }
`

const ProductImage = styled(GatsbyImage)`
  height: 80%;
  width: 100%;
  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    height: auto !important;
    overflow: hidden;
  }
`

const ProductDetail = styled.div`
  font-size: ${(props) => props.theme.fontSize.m23};
  text-decoration: none;
  color: ${(props) => props.theme.colors.black};
  margin-top: ${(props) => props.theme.space.marginMobile / 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin-top: ${(props) => props.theme.space.marginDesktop * 1.5}vw;
    margin-bottom: ${(props) => props.theme.space.marginDesktop}vw;
    font-size: ${(props) => props.theme.fontSize.d15};
  }
`

const ProductSubheading = styled.p`
  margin-top: ${(props) => props.theme.space.marginMobile / 2}vw;
  font-size: ${(props) => props.theme.fontSize.m18};
  color: ${(props) => props.theme.colors.grey};

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin-top: ${(props) => props.theme.space.marginDesktop}vw;
    font-size: ${(props) => props.theme.fontSize.d15};
  }
`

const PriceSpan = styled.span`
  color: ${(props) => (props.sale ? '#E83C38' : 'inherent')};
  font-weight: ${(props) => (props.sale ? 'bold' : 'inherent')};
`
const OldPriceSpan = styled.span`
  text-decoration: line-through;
`

const AriaLabel = styled.p`
  visibility: hidden;
  display: none;
`

const ProductLogoWrapper = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    width: 100%;
  }
`
export default ProductThumbnail
